import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../ui/tabs";
import { Typography, Button } from "@mui/material";
import CustomModal from "../../modal/CustomModal";
import EditHistoryMacros from "../modals/EditHistoryMacros";
import PropTypes from "prop-types";
import { connect } from "react-redux";
const MacroItem = ({ data, servings = 1 }) => {
  const value = servings === 1 ? data.amount : data.amount * servings;

  return (
    <div className="flex flex-row justify-between items-center">
      <Typography variant="subtitle1" className="font-normal leading-snug">
        {data.name}
      </Typography>
      <div className="flex-1 border-b border-separator mx-2"></div>
      <div className="flex flex-row">
        <Typography variant="body2">{value % 1 === 0 ? value.toFixed(0) : value.toFixed(2)}</Typography>
        {data.unit && <Typography variant="body2">&nbsp;{data.unit.name}</Typography>}
      </div>
    </div>
  );
};
const HistoryItemMacroSection = ({ macroSectionIndex, historyIndex, insights: { recipeHistory }, date }) => {
  const section = recipeHistory[historyIndex].macros.sections[macroSectionIndex];
  const [activeTab, setActiveTab] = useState("total");
  const [showEditServingsEatenModal, setShowEditServingsEatenModal] = useState(false);

  const handleCloseEditServingsEatenModal = () => {
    setShowEditServingsEatenModal(false);
  };

  return (
    <>
      {section.macros.length > 0 && (
        <div className="w-full mb-4">
          <CustomModal
            open={showEditServingsEatenModal}
            handleClose={handleCloseEditServingsEatenModal}
            type="bottomToCentered"
          >
            <EditHistoryMacros
              historyIndex={historyIndex}
              macroSectionIndex={macroSectionIndex}
              handleClose={() => handleCloseEditServingsEatenModal()}
            />
          </CustomModal>
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsContent value="single">
              <div>
                {section?.name && section.name !== "" && (
                  <div className="p-4 bg-neutral-100">
                    <Typography variant="h6" className="font-normal">
                      {section.name}
                    </Typography>
                  </div>
                )}

                <div className="px-4 pt-4">
                  <Typography variant="subtitle1" className="font-medium leading-snug">
                    1 Serving
                  </Typography>
                  <div className="pb-4 border-b border-secondaryText-600">
                    <Typography variant="body2" className="font-normal leading-snug text-secondaryText-600">
                      ({section.servingSize})
                    </Typography>
                  </div>
                </div>

                <div className="px-4">
                  <TabsList className="w-full my-4">
                    <TabsTrigger value="total" className="flex-1">
                      Total Macros
                    </TabsTrigger>
                    <TabsTrigger value="single" className="flex-1">
                      Single Serving
                    </TabsTrigger>
                  </TabsList>
                </div>

                <div className="mt-4 px-4">
                  {section.macros.map((macro, i) => (
                    <MacroItem key={`macro-${i}`} data={macro} servings={1} />
                  ))}
                </div>
              </div>
            </TabsContent>

            <TabsContent value="total">
              <div>
                {section?.name && section.name !== "" && (
                  <div className="p-4 bg-neutral-100">
                    <Typography variant="h6" className="font-normal">
                      {section.name}
                    </Typography>
                  </div>
                )}
                <div className="flex flex-row justify-between items-start border-b border-secondaryText mx-4 pt-4">
                  <div>
                    <Typography variant="subtitle1" className="font-medium leading-snug">
                      {`${section.servingsEaten && section.servingsEaten !== "" ? section.servingsEaten : 0} ${
                        section.servingsEaten === 1 ? "Serving" : "Servings"
                      }`}
                    </Typography>

                    <div className="pb-4">
                      <Typography variant="body2" className="font-normal leading-snug text-secondaryText-600">
                        ({section.servingSize})
                      </Typography>
                    </div>
                  </div>

                  <Button
                    onClick={() => setShowEditServingsEatenModal(true)}
                    className="py-1 pr-0 pl-2 flex flex-row justify-end hover:bg-transparent"
                    disableRipple
                  >
                    <div>
                      <Typography variant="caption" className="text-mainGreen font-medium">
                        Edit
                      </Typography>
                    </div>
                  </Button>
                </div>
                <div className="px-4">
                  <TabsList className="w-full my-4">
                    <TabsTrigger value="total" className="flex-1">
                      Total Macros
                    </TabsTrigger>
                    <TabsTrigger value="single" className="flex-1">
                      Single Serving
                    </TabsTrigger>
                  </TabsList>
                </div>

                <div className="mt-4 px-4">
                  {section.macros.map((macro, i) => (
                    <MacroItem key={`macro-${i}`} data={macro} servings={section.servingsEaten} date={date} />
                  ))}
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      )}
    </>
  );
};

HistoryItemMacroSection.propTypes = {
  macroSectionIndex: PropTypes.number.isRequired,
  historyIndex: PropTypes.number.isRequired,
  insights: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  insights: state.insights,
});

export default connect(mapStateToProps)(HistoryItemMacroSection);
